import { generateChart } from 'vue-chartjs'
require('chartjs-chart-box-and-violin-plot')

export default generateChart('boxplot-chart', 'boxplot')
